/* Aasraa Warranty Policy controls, v6. Scoped to the warranty page only. */
(function () {
  'use strict';
  function setup(root) {
    if (!root || root.dataset.awReady === 'true') return;
    root.dataset.awReady = 'true';
    var panels = Array.prototype.slice.call(root.querySelectorAll('details.aw-panel'));
    var expandButton = root.querySelector('.aw-toggle');
    var nav = root.querySelector('.aw-nav');
    var navToggle = root.querySelector('.aw-nav-toggle');
    var navLinks = root.querySelector('.aw-nav-links');
    if (!panels.length) return;

    function updateButton() {
      if (!expandButton) return;
      var allOpen = panels.every(function (p) { return p.open; });
      expandButton.textContent = allOpen ? 'Collapse all' : 'Expand all';
      expandButton.setAttribute('aria-expanded', String(allOpen));
    }
    function setPanel(panel, open) {
      // Use the native open attribute, not a simulated click on <summary>.
      if (open) panel.setAttribute('open', '');
      else panel.removeAttribute('open');
    }
    function closeNav() {
      if (!nav || !navToggle) return;
      nav.classList.remove('aw-nav-open');
      navToggle.setAttribute('aria-expanded', 'false');
    }
    function findMainHeader() {
      var candidates = ['#shopify-section-header','.shopify-section-header-sticky','.section-header','.header-wrapper','header.header'];
      for (var i = 0; i < candidates.length; i++) {
        var el = document.querySelector(candidates[i]);
        if (el && el !== nav && el.getBoundingClientRect().height > 0) return el;
      }
      return null;
    }
    function visibleHeaderBottom() {
      var header = findMainHeader();
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return 0;
      return Math.max(0, Math.min(window.innerHeight, rect.bottom));
    }
    function headerOffset() { return visibleHeaderBottom() + 14; }
    function positionStickyNav() {
      if (!nav || !window.matchMedia('(max-width: 800px)').matches) return;
      nav.style.top = visibleHeaderBottom() + 'px';
    }
    var repositionFrame = null;
    function scheduleNavPosition() {
      if (repositionFrame !== null) return;
      repositionFrame = window.requestAnimationFrame(function () {
        repositionFrame = null;
        positionStickyNav();
      });
    }
    window.addEventListener('scroll', scheduleNavPosition, { passive: true });
    window.addEventListener('resize', scheduleNavPosition);
    positionStickyNav();
    function goToPanel(panel, smooth) {
      setPanel(panel, true);
      updateButton();
      closeNav();
      scheduleNavPosition();
      var scroll = function () {
        var top = panel.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
      };
      // Wait for the accordion and mobile nav layout to settle before measuring.
      requestAnimationFrame(function () { requestAnimationFrame(scroll); });
    }

    if (expandButton) {
      expandButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var shouldOpen = panels.some(function (p) { return !p.open; });
        panels.forEach(function (p) { setPanel(p, shouldOpen); });
        updateButton();
      });
    }
    if (navToggle) {
      navToggle.addEventListener('click', function (event) {
        event.preventDefault();
        var opened = nav.classList.toggle('aw-nav-open');
        navToggle.setAttribute('aria-expanded', String(opened));
        scheduleNavPosition();
      });
    }
    if (navLinks) {
      navLinks.addEventListener('click', function (event) {
        var link = event.target.closest('a[href^="#"]');
        if (!link || !navLinks.contains(link)) return;
        var id = link.getAttribute('href').slice(1);
        var panel = document.getElementById(id);
        if (!panel || !root.contains(panel)) return;
        event.preventDefault();
        event.stopPropagation();
        goToPanel(panel, true);
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + encodeURIComponent(id));
        }
      });
    }
    panels.forEach(function (p) { p.addEventListener('toggle', updateButton); });
    updateButton();

    function openHash() {
      var id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return; }
      var target = id && document.getElementById(id);
      if (target && root.contains(target) && target.matches('details.aw-panel')) {
        goToPanel(target, false);
      }
    }
    window.addEventListener('hashchange', openHash);
    if (window.location.hash) openHash();
  }
  function init() {
    document.querySelectorAll('.aw-page').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
